export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/readiwriterwriting-full-7365f5f2c0998289343782a465f86627.svg";